module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place master-transactions column"
  }, [_c('div', {
    staticClass: "white-box row ctn-transactions-reminder"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column labels"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t  \t\tVous avez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.subscriptions.length) + " abonnement" + _vm._s((_vm.subscriptions.length > 1) ? 's' : ''))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'MySubscriptionsAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\tNouvel abonnement\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\tAbonnements\n\t")]), _vm._v(" "), _c('ag-table', {
    attrs: {
      "rows": _vm.computedRows,
      "columns": _vm.cols,
      "customOptions": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-operations-folder"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e3676cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MySubscriptions/Table.vue
// module id = 1147
// module chunks = 0